/* The preview side of the Lienzo editor (the mockup's `.pv`): the toolbar, then the active panel. */
.viewer {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-block-size: 0;
  background: var(--canvas);
}

/* The in-page fallback of full screen: the wrapper covers the window. */
.viewer[data-maximised="true"] {
  position: fixed;
  inset: 0;
  z-index: 100;
}

.panel {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-3);
  min-block-size: 0;
  overflow: auto;
}

.panel[hidden] {
  display: none;
}

/* The code and the console sit on the canvas like the mockup's `.code` and `.console` cards. */
.panel:not(:first-of-type) {
  padding: var(--space-6);
}

.notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  margin: var(--space-2) var(--space-2) 0;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
}

.noticeText {
  margin: 0;
}

.empty {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.hint {
  margin: 0;
  color: var(--text-muted);
}

/* The frame fills its scaler, which carries the layout width. */
.frame {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0;
  background: var(--surface-raised);
}
